import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, KiloClassType, KiloClassTypeWrite } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateKiloClassType(): UseMutationResult<
  AxiosResponse<KiloClassType>,
  AxiosError<ErrorMessage>,
  KiloClassTypeWrite
> {
  const queryClient = useQueryClient();

  const updateKiloClassType = (kiloClassType: KiloClassTypeWrite): Promise<AxiosResponse<KiloClassType>> => {
    return client.put(`kilo-class-types/${kiloClassType?.kiloClassTypeId}/`, kiloClassType);
  };

  return useMutation(updateKiloClassType, {
    onSuccess: () => {
      queryClient.invalidateQueries(['classType']);
      queryClient.invalidateQueries({
        queryKey: ['classPayRateLookups'],
      });
    },
  });
}
